// eslint-disable-next-line no-unused-vars
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import IndexComponents from 'components/Index/index.components';

const IndexPage = (props: any) => {
   return (
      <Fragment>
         <Helmet>
            <title>ล็อคอิน</title>
         </Helmet>
            <IndexComponents {...props}/>
      </Fragment>
   );
};

export default IndexPage;
